import { withCompController } from '@wix/editor-elements-integrations/thunderbolt'
import type { ColumnsRepeaterCompProps, ColumnsRepeaterStateRefValues } from './types'

export const ColumnsRepeaterController = withCompController<
	ColumnsRepeaterCompProps,
	ColumnsRepeaterCompProps,
	ColumnsRepeaterCompProps,
	ColumnsRepeaterStateRefValues
>(({ mapperProps, stateValues }) => {
	return {
		...mapperProps,
		observeChildListChange: mapperProps.isMasterPage
			? stateValues.observeChildListChangeMaster
			: stateValues.observeChildListChange,
	}
})
